import DropDown from "./components/Dropdown.vue";
import { ValidationProvider } from "vee-validate";
import { ValidationObserver } from "vee-validate";
import Select2 from "v-select2-component";
import { Datetime } from "vue-datetime";
import { SlideYDownTransition } from "vue2-transitions";

/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install(Vue) {
    Vue.component("drop-down", DropDown);
    Vue.component("ValidationProvider", ValidationProvider);
    Vue.component("ValidationObserver", ValidationObserver);
    Vue.component("Select2", Select2);
    Vue.component("VueDatetime", Datetime);
    Vue.component("SlideYDownTransition", SlideYDownTransition);
  }
};

export default GlobalComponents;
